/**
 * @generated SignedSource<<76e50ab7ccc5809bae1f38619a3460b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserEventsPastSection_user$data = {
  readonly id: string;
  readonly pastEvents: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"EventList_eventsConnection">;
  };
  readonly " $fragmentType": "UserEventsPastSection_user";
};
export type UserEventsPastSection_user$key = {
  readonly " $data"?: UserEventsPastSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserEventsPastSection_user">;
};

import UserEventsPastSectionPaginationQuery_graphql from './UserEventsPastSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "pastEvents"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserEventsPastSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserEventsPastSection_user",
  "selections": [
    {
      "alias": "pastEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "PAST"
        }
      ],
      "concreteType": "EventsConnection",
      "kind": "LinkedField",
      "name": "__UserEventsPastSection_user_pastEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventList_eventsConnection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserEventsPastSection_user_pastEvents_connection(timeSelection:\"PAST\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "444812a2898837b7b33775eb3d562a35";

export default node;
